/* eslint-disable vue/component-definition-name-casing */
import './assets/css/main.css'

import { createApp } from 'vue'
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar'
import { plugin as VueTippy } from 'vue-tippy'
// import { useAuthStore } from './stores/auth'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import vSelect from 'vue-select'

import  pinia  from './stores/index'
import { i18n } from './i18n/index'

import App from './App.vue'
import router from './router'

import setup from './http/interceptor'

//import global layout
import ModalLoader from './components/reusables/ModalLoader.vue'
import PublicLayout from './components/layouts/PublicLayout.vue'
import ErrorLayout from './components/layouts/ErrorLayout.vue'
import AuthLayout from './components/layouts/AuthLayout.vue'
import HomeLayout from './components/layouts/HomeLayout.vue'
import AdminLayout from './components/layouts/AdminLayout.vue'
import MessageBox from '@/components/reusables/modals/MessageBox.vue';
import CoolCheckbox from './components/reusables/CoolCheckbox.vue'
import DropdownLoader from './components/reusables/DropdownLoader.vue'

//import global icon
import NeoIcon from '@/components/reusables/NeoIcon.vue'

const app = createApp(App)

//global components
app.component('v-select', vSelect)
app.component('auth-layout', AuthLayout)
app.component('home-layout', HomeLayout)
app.component('admin-layout', AdminLayout)
app.component('public-layout', PublicLayout)
app.component('error-layout', ErrorLayout)
app.component('message-box', MessageBox)
app.component('neo-icon', NeoIcon)
app.component('cool-checkbox', CoolCheckbox)
app.component('modal-loader', ModalLoader)
app.component('dropdown-loader', DropdownLoader)


app.use(VueReCaptcha, {
  siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true,
  }
})


app.use(pinia)
app.use(i18n)

app.use(router)
setup()

app.use(VueTippy, {
  directive: 'tippy',
  component: 'tippy',
  componentSingleton: 'tippy-singleton',
  defaultProps: {
      allowHTML: true,
      animation: 'perspective',
      placement: 'bottom',
      theme: 'light',
      touch: 'hold'
  }
})

app.use(PerfectScrollbarPlugin, {
  componentName: 'Scrollbar',
  watchOptions: true,
  options: {
    suppressScrollY: true
  }
})

app.directive('focus', {
  mounted(el: any) {
    el.focus()
  }
})


app.mount('#app')
